
import { Options } from "vue-class-component";
import Base from "./../base/Base.vue";
import AuthService from "../../services/auth.service";
import { ScreenType } from "../../enum/screen.type";
@Options({})
export default class ProfileHeader extends Base {
  items = [
    {
      label: "Account",
      icon: "pi pi-user",
      command: () => {
        this.redirectTo(ScreenType.profile);
      }
    },
    {
      label: "Logout",
      icon: "pi pi-sign-out",
      command: () => {
        AuthService.signOut();
      }
    }
  ];
}
